import {
  PROJECTS_RECEIVED_CREATE_CUSTOMER_GROUP,
  PROJECTS_RECEIVED_CREATE_CUSTOMER_GROUP_MEMBER,
  PROJECTS_RECEIVED_DELETE_CUSTOMER_GROUP,
  PROJECTS_RECEIVED_DELETE_CUSTOMER_GROUP_MEMBER,
  PROJECTS_RECEIVED_GET_CUSTOMER_GROUPS,
  PROJECTS_RECEIVED_UPDATE_CUSTOMER_GROUP,
} from "../../legacy/actions/project-actions";
import { legacyFulfill } from "../utils";
import { BuilderType, projectsCacheTags } from "./projectsApiHelpers";

export type CustomerGroup = {};
export type CustomerGroupMember = {};
export const customerGroupsApi = (builder: BuilderType) => ({
  getCustomerGroups: builder.query<CustomerGroup, void>({
    query: () => `service/customer-groups`,
    onQueryStarted: legacyFulfill(PROJECTS_RECEIVED_GET_CUSTOMER_GROUPS),
    providesTags: [projectsCacheTags.CUSTOMER_GROUPS],
  }),

  createCustomerGroup: builder.mutation<CustomerGroup, any>({
    query: (customerGroup) => ({
      url: `service/customer-groups`,
      method: "POST",
      body: customerGroup,
    }),
    invalidatesTags: [projectsCacheTags.CUSTOMER_GROUPS],
    onQueryStarted: legacyFulfill(PROJECTS_RECEIVED_CREATE_CUSTOMER_GROUP),
  }),

  updateCustomerGroup: builder.mutation<CustomerGroup, any>({
    query: (customerGroup) => ({
      url: `service/customer-groups/${customerGroup.id}`,
      method: "PUT",
      body: customerGroup,
    }),
    invalidatesTags: [projectsCacheTags.CUSTOMER_GROUPS],
    onQueryStarted: legacyFulfill(PROJECTS_RECEIVED_UPDATE_CUSTOMER_GROUP),
  }),

  deleteCustomerGroup: builder.mutation<CustomerGroup, number>({
    query: (id) => ({
      url: `service/customer-groups/${id}`,
      method: "DELETE",
    }),
    invalidatesTags: [projectsCacheTags.CUSTOMER_GROUPS],
    onQueryStarted: legacyFulfill(PROJECTS_RECEIVED_DELETE_CUSTOMER_GROUP),
  }),

  createCustomerGroupMember: builder.mutation<CustomerGroupMember, any>({
    query: (customerGroupMember) => ({
      url: `service/customer-groups/members`,
      method: "POST",
      body: customerGroupMember,
    }),
    invalidatesTags: [projectsCacheTags.CUSTOMER_GROUPS],
    onQueryStarted: legacyFulfill(
      PROJECTS_RECEIVED_CREATE_CUSTOMER_GROUP_MEMBER
    ),
  }),

  deleteCustomerGroupMember: builder.mutation<CustomerGroupMember, number>({
    query: (id) => ({
      url: `service/customer-groups/members/${id}`,
      method: "DELETE",
    }),
    invalidatesTags: [projectsCacheTags.CUSTOMER_GROUPS],
    onQueryStarted: legacyFulfill(
      PROJECTS_RECEIVED_DELETE_CUSTOMER_GROUP_MEMBER
    ),
  }),
});
